import axios, {} from "axios";
import {ACCESS_TOKEN} from "./localStorage";
import { Service } from "axios-middleware";

const service = new Service(axios);

service.register({
    onRequest(config) {
        let accessToken = localStorage.getItem(ACCESS_TOKEN)
        if (accessToken) {
            config.headers.Authorization = `Bearer ${accessToken}`
        }
        return config
    }
});

const Api = axios.create({
    baseURL:'/api/'
});

Api.interceptors.response.use(
    response => response,
    error => Promise.reject(error.response)
)
Api.interceptors.request.use(config => {
    // Print this before sending any HTTP request
    console.log('Request was sent');
    return config;
});
export default Api;

